import React, {useEffect, useRef, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {useDispatch} from 'react-redux';
import axios from 'axios';
import Cookies from 'js-cookie';

import actions from 'actions/index.js';
import * as constants from 'constants/index.js';
import CardsHeader from 'layouts/Headers/CardsHeader.js';

import TableCustom from 'views/pages/components/TableCustom';

import {Button, Card, CardBody, CardHeader, Col, Container, Row,} from 'reactstrap';

import {InputKeySelect} from '../components/InputSelect';
import CustomSearch from "@pages/components/CustomSearch";
import {ButtonContainer} from "@pages/reusable-components/styled-components";
import notify from '@utils/notify';

export default function Tracking() {
  const history = useHistory();

  const dispatch = useDispatch();

  const [token, setToken] = useState('');
  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState('');
  const [devices, setDevices] = useState([]);
  const [dealers, setDealers] = useState('');
  const [filter, setFilter] = useState('');

  useEffect(() => {

    window.addEventListener('message', function (event) {
      if (typeof event.data === 'string' && event.data.indexOf('MapView|') === 0) {
        console.log(event.data)
      }
    })

    const grs_token = Cookies.get('grs_token')
    setToken(grs_token)
    dispatch(actions.getProfileData(grs_token));

    const source = axios.CancelToken.source()

    fetchData(source, 1, grs_token, '')

    return () => {
      source.cancel()
    }
  }, [])

  const fetchData = async (source, pageNumber, token, filter) => {
    try {
      const response = await axios({
        method: 'GET',
        url: `${constants.API_URL}/tracking/device`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          ...filter,
          search: filter.searchValue,
          page: pageNumber
        },
        cancelToken: source.token,
      })
      console.log('response :: ', response.data)
      const data = response.data

      setItems(data.data.items)
      setDevices(data.data.items.data)
      setDealers(data.data.dealers)

      setTimeout(() => {
        setLoading(false)
      }, 500);
    } catch (error) {
      setLoading(false)
      if (axios.isCancel(error)) {
        console.log('Request canceled :: ', error)
      } else {
        console.error('error :: ', error)
        notify.warning(error.response && error.response.data ? error.response.data.message : error.response ? error.response.statusText : 'Error Occurred!')
      }
    }
  }

  const filterTracking = () => {
    const source = axios.CancelToken.source()
    fetchData(source, 1, token, {
      ...filter,
      search: filter.searchValue ? filter.searchValue : undefined
    })
  }

  const resetTracking = () => {
    setFilter('')
    const source = axios.CancelToken.source()
    fetchData(source, 1, token, '')
  }

  const editTracking = (row) => {
    history.push({
      pathname: `/admin/tracking/device/${row.uuid}`
    })
  }

  return (
    <>
      <CardsHeader name="Tracking Management" parentName="Tracking Management" currentName="List" />
      <Container className="mt--5 admin-main-body" fluid >
        <Row>
          <Col xl="12">
            <Card>
              <CardHeader>
                <div className="d-flex justify-content-between">
                  <div>
                    <h1 className="title">Tracking Management</h1>
                    <span className="text-sm mb-0">Manage all your Tracked vehicles here.</span>
                  </div>
                </div>
              </CardHeader>
              <CardBody>
               <Row>
                  <Col  lg={3}>
                    <InputKeySelect
                        newLabel={`Dealer`}
                        options={dealers}
                        value={filter && filter.dealer_id ? filter.dealer_id : ''}
                        onChange={e => setFilter({
                          ...filter,
                          dealer_id: e.target.value
                        })}
                        defaultOption={true}
                    />
                  </Col>
                  <Col lg={3}>
                    <CustomSearch
                        inputWidth={'100%'}
                        border={'1px solid #ccc'}
                        borderRadius={'8px'}
                        paddingTop={'7px'}
                        paddingBottom={'7px'}
                        defaultValue={filter['search']}
                        onChange={e => setFilter({
                          ...filter,
                          searchValue: e.target.value
                        })}
                        placeholder="Search"
                    />
                  </Col>
                    <Col lg={2}>
                      <ButtonContainer   style={{ margin: 5 }} onClick={() => resetTracking()}>Reset</ButtonContainer>
                    </Col>
                    <Col lg={2}>
                      <ButtonContainer  reverse style={{ margin: 5 }} onClick={() => filterTracking()}>Filter</ButtonContainer>
                    </Col>
               </Row>
              </CardBody>
              <CardBody>
                <TableCustom
                  loading={loading}
                  items={devices}
                  noOverflow
                  pagination={items}
                  onChange={(pageNumber) => fetchData(axios.CancelToken.source(), pageNumber, token, filter)}
                  columns={[
                    {
                      dataField: "vehicle",
                      text: "Vehicle",
                      sort: true,
                      formatter: (rowContent, row) => {
                        return `${row.vehicle.vehicle_make.name} ${row.vehicle.vehicle_model.name} ${row.device_type ? `(${row.device_type})` : ''}`
                      }
                    },
                    {
                      dataField: "stock_no",
                      text: "Stock No",
                      sort: true,
                      formatter: (rowContent, row) => {
                        return row.vehicle.stock_no ? row.vehicle.stock_no : ''
                      }
                    },
                    {
                      dataField: "current_customer",
                      text: "Current Customer",
                      sort: true,
                      formatter: (rowContent, row) => {
                        return row.customer ? row.customer.full_name : '-'
                      }
                    },
                    {
                      dataField: "contact_number",
                      text: "Contact Number",
                      sort: true,
                      formatter: (rowContent, row) => {
                        return row.customer ? row.customer.mobile_number : '-'
                      }
                    },
                    {
                      dataField: "tracker_status",
                      text: "Tracker Status",
                      sort: true,
                      formatter: (rowContent, row) => {
                        return row.is_not_immobilised === 1 ? 'On' : 'Off'
                      }
                    },
                    {
                      dataField: "is_primary",
                      text: "Primary",
                      sort: true,
                      formatter: (rowContent, row) => {
                        return row.is_primary === 1 ? 'On' : 'Off'
                      }
                    },
                    {
                      dataField: "",
                      text: "Action",
                      formatter: (rowContent, row) => {
                        return (
                          <>
                            <Button
                                onClick={() => editTracking(row)}
                            >
                              View
                            </Button>
                          </>
                        )
                      }
                    }
                  ]}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
        <iframe src="https://flespi.io/mapview/" width="0" height="0"></iframe>
      </Container>
    </>
  )
}